var cov_1xm8cy6jt2 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tree/Root.tsx",
      hash = "54c240cbc06daa4708121efd60a34cbf72c26602",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tree/Root.tsx",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 20
        },
        end: {
          line: 9,
          column: 119
        }
      },
      "1": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 11,
          column: 88
        }
      },
      "2": {
        start: {
          line: 14,
          column: 0
        },
        end: {
          line: 17,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "Root",
        decl: {
          start: {
            line: 8,
            column: 9
          },
          end: {
            line: 8,
            column: 13
          }
        },
        loc: {
          start: {
            line: 8,
            column: 80
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 46
          },
          end: {
            line: 9,
            column: 82
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 9,
            column: 59
          },
          end: {
            line: 9,
            column: 70
          }
        }, {
          start: {
            line: 9,
            column: 73
          },
          end: {
            line: 9,
            column: 82
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 9,
            column: 84
          },
          end: {
            line: 9,
            column: 100
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 9,
            column: 84
          },
          end: {
            line: 9,
            column: 91
          }
        }, {
          start: {
            line: 9,
            column: 95
          },
          end: {
            line: 9,
            column: 100
          }
        }],
        line: 9
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tree/Root.tsx";
import React from 'react';
import classnames from 'classnames';
import { treeClass } from './styles';
import List from './List';
import { isRTL } from '../config';

function Root(props) {
  cov_1xm8cy6jt2.f[0]++;
  var className = (cov_1xm8cy6jt2.s[0]++, classnames(treeClass('_', props.line ? (cov_1xm8cy6jt2.b[0][0]++, 'with-line') : (cov_1xm8cy6jt2.b[0][1]++, 'no-line'), (cov_1xm8cy6jt2.b[1][0]++, isRTL()) && (cov_1xm8cy6jt2.b[1][1]++, 'rtl')), props.className));
  cov_1xm8cy6jt2.s[1]++;
  return (
    /*#__PURE__*/
    React.createElement(List, Object.assign({}, props, {
      className: className,
      expanded: true,
      path: "",
      isRoot: true,
      deepIndex: 0,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 11,
        columnNumber: 10
      }
    }))
  );
}

cov_1xm8cy6jt2.s[2]++;
Root.defaultProps = {
  data: [],
  line: true
};
export default Root;